// The ⋮ panel's shared type, for the budget cards on /analysis.
//
// Both cards' menus carry the same two sections — a short "איך מחושב" with a
// worked example, and a "חשוב לדעת" glossary — and they must not drift the way
// the two amber callouts once did (see AmberCallout). One definition, imported
// by both.
//
// The glossary's shape is the point: a CHIP showing the label EXACTLY as it
// appears on the card, then what it means. The reader arrived here because
// they saw the label, not because they knew what to call it.
export const CHIP_ROW = { display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 5 };
export const CHIP = {
  fontSize: 11.5, color: 'var(--ink-muted)', background: '#f1f5f9',
  borderRadius: 6, padding: '2px 7px', whiteSpace: 'nowrap',
};
export const NOTE = { margin: 0, fontSize: 12.5, color: '#475569', lineHeight: 1.6 };
// The heading above each section, and the rule that separates them.
export const MENU_SECTION = { borderTop: '1px solid #eef2f7', margin: '6px 0 0', padding: '10px 4px 0' };
export const MENU_HEADING = { fontWeight: 700, color: '#1a1a2e', marginBottom: 8 };
